import CsChart, { ChartList, MyChart } from './CsChart';

const plugins = {};
const componentArray = [
  CsChart, // 简化图表组件
  MyChart, // 接收echart原始option的组件
];

const install = function (Vue, opt = {}) {
  if (plugins.installed) return;
  plugins.installed = true;
  componentArray.forEach((item) => {
    Vue.component(item.name, item);
  });

  ChartList.config(opt);
};

export default {
  install,

  // 获取当前支持图表列表
  getChartList: ChartList.get,
};
